import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  WordBreak_BreakAll_getInstance289x8dja79rdq as WordBreak_BreakAll_getInstance,
} from '../../models/data.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { parseMPNodes2ccjji1gwc8mn as parseMPNodes } from '../../dom/microparse.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var TextViewClass;
function TextView() {
  if (TextViewClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.vb5_1.zb3_1 = 'p';
        this.vb5_1.hbu('\xA0');
        this.vco_1 = Align_Start_getInstance();
        this.wco_1 = true;
        this.xco_1 = true;
        this.yco_1 = null;
      }
      dbs(value) {
        var tmp0 = this.vb5_1.db4_1;
        var tmp;
        switch (value.b4_1) {
          case 0:
            tmp = 'start';
            break;
          case 1:
            tmp = 'center';
            break;
          case 2:
            tmp = 'end';
            break;
          case 3:
            tmp = 'justify';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        // Inline function 'com.lightningkite.kiteui.views.textAlign' call
        var value_0 = tmp;
        tmp0.hb7_1.textAlign = value_0;
      }
      zco(value) {
        this.wco_1 = value;
        var tmp0 = this.vb5_1.db4_1;
        // Inline function 'com.lightningkite.kiteui.views.textOverflow' call
        var value_0 = value ? 'ellipsis' : 'clip';
        tmp0.hb7_1.textOverflow = value_0;
        if (value) {
          this.vb5_1.cb9('overflow', 'hidden');
        } else {
          this.vb5_1.cb9('overflow', null);
        }
      }
      acp(value) {
        this.xco_1 = value;
        this.vb5_1.cb9('text-wrap', value ? 'wrap' : 'nowrap');
        this.vb5_1.cb9('text-wrap-mode', value ? 'wrap' : 'nowrap');
      }
      bcp(value) {
        this.vb5_1.cb9('word-break', value.equals(WordBreak_BreakAll_getInstance()) ? 'break-all' : 'normal');
      }
      ccp(html) {
        var tmp0 = this.vb5_1.db4_1;
        // Inline function 'com.lightningkite.kiteui.views.whiteSpace' call
        var value = 'pre-line';
        tmp0.hb7_1.whiteSpace = value;
        var tmp = this.vb5_1;
        // Inline function 'kotlin.collections.onEach' call
        // Inline function 'kotlin.apply' call
        var this_0 = parseMPNodes(html);
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          element.cax();
        }
        tmp.dcp(joinToString(this_0, ' '));
      }
    }
    initMetadataForClass($, 'TextView');
    TextViewClass = $;
  }
  return TextViewClass;
}
//region block: exports
export {
  TextView as TextViewe6rp77b08kos,
};
//endregion

//# sourceMappingURL=TextView.commonHtml.mjs.map
